import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const LayoutContext = createContext(void 0);
const LayoutProvider = ({ children, config }) => {
  const value = {
    ...config,
    isConfigured: true
  };
  return /* @__PURE__ */ jsx(LayoutContext.Provider, { value, children });
};
const useLayoutConfig = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error(
      "useLayoutConfig must be used within a LayoutProvider. Please wrap your app with <LayoutProvider config={{...}}>"
    );
  }
  return context;
};
const useIsLayoutConfigured = () => {
  const context = useContext(LayoutContext);
  return context?.isConfigured || false;
};
export {
  LayoutProvider,
  useIsLayoutConfigured,
  useLayoutConfig
};
//# sourceMappingURL=layout-context.js.map
